// extracted by mini-css-extract-plugin
export default {"wrapper":"PhotoPage_wrapper__oue7D","back":"PhotoPage_back__Y4fvF","qr_reader":"PhotoPage_qr_reader__YyGXA","wrapper_foto":"PhotoPage_wrapper_foto__fWKwE"};